import { render, staticRenderFns } from "./StudyAudio.vue?vue&type=template&id=23cb12fc&"
import script from "./studyaudio.js?vue&type=script&lang=js&"
export * from "./studyaudio.js?vue&type=script&lang=js&"
import style0 from "./StudyAudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports